import { useState, Fragment, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Sidebar from "../../components/Sidebar";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import { API_URL, MAIN_TITLE, alertMessage } from "../../actions/auth";
import PublicIcon from "@mui/icons-material/Public";
import Fab from "@mui/material/Fab";
import CheckIcon from "@mui/icons-material/Check";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import LocalDiningIcon from "@mui/icons-material/LocalDining";
import GavelIcon from "@mui/icons-material/Gavel";
import BallotIcon from "@mui/icons-material/Ballot";
import ComputerIcon from "@mui/icons-material/Computer";
import HistoryIcon from "@mui/icons-material/History";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import { Link, Navigate, useNavigate } from "react-router-dom";
import CalculateIcon from "@mui/icons-material/Calculate";
import { Chart } from "chart.js/auto";
import Calendar from "react-calendar";
import moment from "moment";
import { CardActionArea } from "@mui/material";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import { themeStyle } from "../../components/Components";
const weekday = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

function getIcon(subject) {
  var sub = subject.toLowerCase();
  if (sub.includes("break") || sub.includes("lunch")) {
    return <LocalDiningIcon style={{ fontSize: 45, color: "black" }} />;
  } else if (sub.includes("mechanic")) {
    return (
      <MenuBookIcon
        style={{ fontSize: 43, color: "black", marginLeft: "2px" }}
      />
    );
  } else if (sub.includes("social")) {
    return (
      <MenuBookIcon
        style={{ fontSize: 43, color: "black", marginLeft: "2px" }}
      />
    );
  } else if (sub.includes("civics")) {
    return <GavelIcon style={{ fontSize: 45, color: "black" }} />;
  } else if (sub.includes("polit")) {
    return <BallotIcon style={{ fontSize: 45, color: "black" }} />;
  } else if (sub.includes("compu")) {
    return <ComputerIcon style={{ fontSize: 45, color: "black" }} />;
  } else if (sub.includes("bio")) {
    return (
      <MenuBookIcon
        style={{ fontSize: 43, color: "black", marginLeft: "2px" }}
      />
    );
  } else if (sub.includes("chem") || sub.includes("scien")) {
    return (
      <MenuBookIcon
        style={{ fontSize: 43, color: "black", marginLeft: "2px" }}
      />
    );
  } else if (
    sub.includes("economics") ||
    sub.includes("accou") ||
    sub.includes("busi")
  ) {
    return (
      <MenuBookIcon
        style={{ fontSize: 43, color: "black", marginLeft: "2px" }}
      />
    );
  } else if (
    sub.includes("geom") ||
    sub.includes("archi") ||
    (sub.includes("engg") && sub.includes("draw"))
  ) {
    return (
      <MenuBookIcon
        style={{ fontSize: 43, color: "black", marginLeft: "2px" }}
      />
    );
  } else if (sub.includes("geo")) {
    return <PublicIcon style={{ fontSize: 45, color: "black" }} />;
  } else if (sub.includes("math")) {
    return <CalculateIcon style={{ fontSize: 45, color: "black" }} />;
  } else if (sub.includes("history")) {
    return <HistoryIcon style={{ fontSize: 45, color: "black" }} />;
  } else {
    return (
      <MenuBookIcon
        style={{ fontSize: 43, color: "black", marginLeft: "2px" }}
      />
    );
  }
}

const colorList = [
  "#e5f5f9",
  "#e0ecf4",
  "#fee8c8",
  "#ece7f2",
  "#f0f0f0",
  "#fde0dd",
  "#efedf5",
  "#e5f5e0",
  themeStyle.primaryColorLight,
  "#fee6ce",
  "#e5f5f9",
  "#e0ecf4",
  "#fee8c8",
  "#ece7f2",
  "#f0f0f0",
  "#fde0dd",
  "#efedf5",
  "#e5f5e0",
  themeStyle.primaryColorLight,
  "#fee6ce",
];
const colorList2 = [
  "#2ca25f",
  "#8856a7",
  "#e34a33",
  "#1c9099",
  "#636363",
  "#c51b8a",
  "#756bb1",
  "#31a354",
  themeStyle.primaryColor,
  "#e6550d",
];

const colorList3 = [
  "#99d8c9",
  "#9ebcda",
  "#fdbb84",
  "#a6bddb",
  "#bdbdbd",
  "#fa9fb5",
  "#bcbddc",
  "#addd8e",
  "#9ecae1",
  "#a1d99b",
];

function Dashboard() {
  const dispatch = useDispatch();
  function createAlert(type, title, message) {
    dispatch(alertMessage(type, title, message));
  }
  const navigate = useNavigate();

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedDay, setSelectedDay] = useState(weekday[new Date().getDay()]);
  const [isLoading, setIsLoading] = useState(true);
  const handleDateChange = (date) => {
    setSelectedDate(date);
    setSelectedDay(weekday[date.getDay()]);
  };
  const [studentLeaveRequests, setStudentLeaveRequests] = useState([]);

  const params = new URLSearchParams(window.location.search);
  const state = useSelector((state) => state);
  const graph = {
    dataLine: {
      labels: ["January", "February", "March", "April", "May", "June", "July"],
      datasets: [
        {
          label: "Students failed",
          fill: true,
          lineTension: 0.3,
          backgroundColor: "rgba(225, 204,230, .3)",
          borderColor: "#ff3333",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#ff3333",
          pointBackgroundColor: "#ff3333",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "rgb(0, 0, 0)",
          pointHoverBorderColor: "rgba(220, 220, 220,1)",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 5,
          data: [65, 59, 80, 81, 56, 55, 40],
        },
      ],
    },
  };
  const [rankersList, setRankersList] = useState([]);
  const [importantDatesList, setImportantDatesList] = useState([]);
  const [holidayList, setHolidayList] = useState([]);
  const [timeTable, setTimeTable] = useState({});
  const [eventsList, setEventsList] = useState([]);
  const [assignmentList, setAssignmentList] = useState([]);
  const [importantDatesDateList, setImportantDatesDateList] = useState([]);
  const [holidayDateList, setHolidayDateList] = useState([]);
  const [eventsDateList, setEventsDateList] = useState([]);
  const [examDateList, setExamDateList] = useState([]);
  const [exams, setExams] = useState([]);

  const [selectedPage, setSelectedPage] = useState(
    params.get("tab") ? params.get("tab") : "HOME"
  );

  const handlePageSelect = (event) => {
    setSelectedPage(event.currentTarget.value);
  };

  const [noticeBoard, setNoticeBoard] = useState({});

  function sortScheduleByTime(schedule) {
    Object.keys(schedule).forEach((day) => {
      if (Array.isArray(schedule[day])) {
        schedule[day].sort((a, b) => {
          const getTimeValue = (timeStr) => {
            const [time, period] = timeStr.split(" ").slice(0, 2);
            const [h, m] = time.split(":").map(Number);
            let hours = h;
            if (period === "pm" && h !== 12) hours += 12;
            if (period === "am" && h === 12) hours = 0;
            return hours * 100 + m;
          };
          return getTimeValue(a.time) - getTimeValue(b.time);
        });
      }
    });
    return schedule;
  }

  function getData() {
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,

        "Content-Type": "application/json",
      },
    };
    body["institution_id"] = state.auth.user.institution_id;
    body["user_id"] = state.auth.user.user_id;
    body["class_type"] = state.auth.classType;
    body = JSON.stringify(body);
    axios.post(API_URL + "/get_time_table_teacher", body, config).then((res) => {
      const sortedSchedule = sortScheduleByTime(res.data);
      console.log(res.data);
      setTimeTable(sortedSchedule);
      axios.post(API_URL + "/get_events_list", body, config).then((res) => {
        var tempEventsList = res.data["events_list"];
        var tempHolidayList = res.data["holidays_list"];
        var tempImportantDatesList = res.data["important_dates_list"];

        var tempEventsDateList = [];
        for (var i = 0; i < res.data["events_list"].length; i++) {
          tempEventsDateList.push(res.data["events_list"][i]["date"]);
        }
        setEventsDateList(tempEventsDateList);

        var tempHolidayDateList = [];
        for (var i = 0; i < res.data["holidays_list"].length; i++) {
          tempHolidayDateList.push(res.data["holidays_list"][i]["date"]);
        }
        setHolidayDateList(tempHolidayDateList);

        var tempImportantDatesDateList = [];
        for (var i = 0; i < res.data["important_dates_list"].length; i++) {
          tempImportantDatesDateList.push(
            res.data["important_dates_list"][i]["date"]
          );
        }
        setImportantDatesDateList(tempImportantDatesDateList);

        for (var i = res.data["events_list"].length - 1; i >= 0; i--) {
          if (
            moment(res.data["events_list"][i]["date"], "DD-MM-YYYY").isBefore(
              moment()
            )
          ) {
            tempEventsList.splice(i, 1);
          }
        }

        setEventsList(tempEventsList);

        for (var i = res.data["holidays_list"].length - 1; i >= 0; i--) {
          if (
            moment(res.data["holidays_list"][i]["date"], "DD-MM-YYYY").isBefore(
              moment()
            )
          ) {
            tempHolidayList.splice(i, 1);
          }
        }

        setHolidayList(tempHolidayList);

        for (var i = res.data["important_dates_list"].length - 1; i >= 0; i--) {
          if (
            moment(
              res.data["important_dates_list"][i]["date"],
              "DD-MM-YYYY"
            ).isBefore(moment())
          ) {
            tempImportantDatesList.splice(i, 1);
          }
        }

        setImportantDatesList(tempImportantDatesList);

        axios
          .post(API_URL + "/get_assignment_list_teacher", body, config)
          .then((res) => {
            var data = res.data;
            data.splice(4, data.length);
            setAssignmentList(data);
            axios
              .post(API_URL + "/get_exams_teacher_dashboard", body, config)
              .then((res) => {
                var tempExamDateList = [];
                var tempExamList = [];

                for (var i = 0; i < res.data.length; i++) {
                  if (
                    !res.data[i]["completed"] &&
                    moment(res.data[i]["start_date"], "DD-MM-YYYY").isAfter(
                      moment()
                    )
                  ) {
                    tempExamList.push(res.data[i]);
                  }
                }

                for (var i = 0; i < tempExamList.length; i++) {
                  for (var j = 0; j < tempExamList[i]["subjects"].length; j++) {
                    var tempSub = tempExamList[i]["subjects"][j];
                    tempExamDateList.push(
                      tempSub[Object.keys(tempSub)[0]]["date"]
                    );
                  }
                }
                setExams(tempExamList);
                setExamDateList(tempExamDateList);
                axios
                  .post(API_URL + "/get_leave_requests_principal", body, config)
                  .then((res) => {
                    var studentpending = 0;
                    var studentapproved = 0;
                    var studentrejected = 0;

                    for (
                      var i = 0;
                      i < res.data["student_requests"].length;
                      i++
                    ) {
                      if (
                        res.data["student_requests"][i]["status"] == "PENDING"
                      ) {
                        studentpending += 1;
                      } else if (
                        res.data["student_requests"][i]["status"] == "APPROVED"
                      ) {
                        studentapproved += 1;
                      } else if (
                        res.data["student_requests"][i]["status"] == "REJECTED"
                      ) {
                        studentrejected += 1;
                      }
                    }
                    setStudentLeaveRequests({
                      PENDING: studentpending,
                      APPROVED: studentapproved,
                      REJECTED: studentrejected,
                    });
                    axios
                      .post(API_URL + "/get_noticeboard_teacher", body, config)
                      .then((res) => {
                        setNoticeBoard(res.data);
                        setIsLoading(false);
                      });
                  });
              })
              .catch((err) => {});
          });
      });
    });
  }

  useEffect(() => {
    if (state.auth.isLoading) {
      dispatch({ type: "ENTRY_PAGE", payload: window.location.pathname });
      navigate("/", { replace: true });
    } else {
      getData();
    }
  }, []);

  if (state.auth.refresh == "REFRESH_DATA") {
    getData();
    dispatch({ type: "REFRESH_DATA", payload: null });
  }

  var colorIndex = 0;
  var today = new Date();

  function getContent() {
    if (selectedPage == "HOME") {
      return (
        <Fade in={true}>
          <Grid container spacing={2}>
            <Grid item md={3}>
              <h2>Timetable</h2>

              {Object.keys(timeTable).length != 0 ? (
                <div style={{ marginTop: "6px" }}>
                  {timeTable[selectedDay] == null ||
                  timeTable[selectedDay].length == 0 ? (
                    <Box
                      borderRadius="15px"
                      style={{
                        backgroundColor: colorList[0],
                        borderBottom: "4px solid " + colorList2[0],
                        width: "100%",
                        padding: "2px",
                        height: "85vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        backgroundImage:
                          "linear-gradient(to right, rgba(251,237,217, 0.9), rgba(251,237,217, 0.9)), url(https://img.freepik.com/free-vector/education-pattern-background-doodle-style_53876-115365.jpg?w=740)",
                      }}
                    >
                      <Fab
                        size="large"
                        style={{
                          height: "100px",
                          width: "100px",
                          border: "5px solid #31a354",
                          boxShadow: "none",
                          backgroundColor: "transparent",
                        }}
                        aria-label="add"
                      >
                        <CheckIcon
                          style={{
                            color: "#31a354",
                            fontSize: "75px",
                          }}
                        />
                      </Fab>
                      <h4 style={{ color: "black" }}>
                        {" "}
                        {state.auth.classType == "STANDARDS"
                          ? " classes "
                          : " lectures "}
                      </h4>
                      <div
                        style={{
                          margin: "-20px 0px 0px 12px",
                          color: "grey",
                          fontSize: "15px",
                        }}
                      >
                        There are no{" "}
                        {state.auth.classType == "STANDARDS"
                          ? " classes "
                          : " lectures "}{" "}
                        scheduled for today
                      </div>
                    </Box>
                  ) : (
                    <Fragment>
                      {timeTable[selectedDay].map((lecture, index) => (
                        <div style={{ marginBottom: "15px" }}>
                          <Grid
                            container
                            spacing={0}
                            justifyContent="flex-start"
                            alignItems="center"
                          >
                            <Grid md={2}>
                              <p
                                style={{
                                  fontSize: "15px",
                                  marginTop: "12px",
                                  color: "grey",
                                }}
                              >
                                {lecture["class"]}
                              </p>
                            </Grid>
                            <Grid item md={10}>
                              <Box
                                borderRadius="10px"
                                style={
                                  lecture["subject"]
                                    .toLowerCase()
                                    .includes("break") ||
                                  lecture["subject"]
                                    .toLowerCase()
                                    .includes("lunch")
                                    ? {
                                        border: "1.5px solid grey",
                                        padding: "2px",
                                        display: "flex",
                                      }
                                    : {
                                        padding: "2px",
                                        display: "flex",
                                        backgroundColor: colorList[index],
                                      }
                                }
                              >
                                <div
                                  style={{
                                    margin:
                                      lecture["subject"]
                                        .toLowerCase()
                                        .includes("break") ||
                                      lecture["subject"]
                                        .toLowerCase()
                                        .includes("lunch")
                                        ? "4px 0px 0px 8px"
                                        : "6px 0px 0px 8px",
                                    color: colorList2[index],
                                  }}
                                >
                                  {getIcon(lecture["subject"])}
                                </div>
                                <div>
                                  <div
                                    style={{
                                      fontWeight: "600",
                                      letterSspacing: "2px",

                                      margin:
                                        lecture["subject"]
                                          .toLowerCase()
                                          .includes("break") ||
                                        lecture["subject"]
                                          .toLowerCase()
                                          .includes("lunch")
                                          ? "1px 0px 0px 12px"
                                          : "3px 0px 0px 12px",
                                      color:
                                        lecture["subject"]
                                          .toLowerCase()
                                          .includes("break") ||
                                        lecture["subject"]
                                          .toLowerCase()
                                          .includes("lunch")
                                          ? "black"
                                          : colorList2[index],
                                      fontSize: "20px",
                                    }}
                                  >
                                    {lecture["subject"]}
                                  </div>
                                  <div
                                    style={{
                                      margin: "-3px 0px 0px 12px",
                                      color:
                                        lecture["subject"]
                                          .toLowerCase()
                                          .includes("break") ||
                                        lecture["subject"]
                                          .toLowerCase()
                                          .includes("lunch")
                                          ? "black"
                                          : colorList2[index],
                                      fontSize: "15px",
                                    }}
                                  >
                                    {lecture["time"]}
                                  </div>
                                </div>
                              </Box>
                            </Grid>
                          </Grid>
                        </div>
                      ))}
                    </Fragment>
                  )}
                  <br></br>
                </div>
              ) : (
                ""
              )}
            </Grid>
            <Grid item md={3} style={{ height: "90vh" }}>
              <h2>Calendar</h2>
              <div style={{ marginTop: "-35px", marginBottom: "15px" }}>
                <Box
                  borderRadius="15px"
                  style={{
                    backgroundColor: colorList[0],
                    marginTop: "40px",
                  }}
                >
                  <div className="calendar-container">
                    <Calendar
                      style={{
                        width: "100%",
                        backgroundColor: "black",
                      }}
                      onChange={handleDateChange}
                      value={selectedDate}
                      tileClassName={({ date, view }) => {
                        if (
                          eventsDateList.find(
                            (x) => x === moment(date).format("DD-MM-YYYY")
                          )
                        ) {
                          return "highlightEvent";
                        } else if (
                          holidayDateList.find(
                            (x) => x === moment(date).format("DD-MM-YYYY")
                          )
                        ) {
                          return "highlightHoliday";
                        } else if (
                          importantDatesDateList.find(
                            (x) => x === moment(date).format("DD-MM-YYYY")
                          )
                        ) {
                          return "highlightImportant";
                        } else if (
                          examDateList.find(
                            (x) => x === moment(date).format("DD-MM-YYYY")
                          )
                        ) {
                          return "highlightExam";
                        } else if (date.getDay() == 6) {
                          return "highlightSaturday";
                        }
                      }}
                    />
                  </div>
                </Box>
                <div
                  style={{
                    marginTop: "5px",
                    marginBottom: "5px",
                    padding: 12,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                  }}
                >
                  <span
                    style={{
                      marginRight: "4px",
                      color: "white",
                      fontSize: "13px",
                      backgroundColor: "#6a6fff",
                      padding: "5px",
                      borderRadius: "20px",
                    }}
                  >
                    {" "}
                    Assignment
                  </span>
                  <span
                    style={{
                      marginRight: "4px",
                      color: "white",
                      fontSize: "13px",
                      backgroundColor: "#a1d99b",
                      padding: "5px",
                      borderRadius: "20px",
                    }}
                  >
                    {" "}
                    Exam
                  </span>

                  <span
                    style={{
                      marginRight: "4px",
                      color: "white",
                      fontSize: "13px",
                      backgroundColor: "#ff3333",
                      padding: "5px",
                      borderRadius: "20px",
                    }}
                  >
                    {" "}
                    Holiday
                  </span>

                  <span
                    style={{
                      marginRight: "4px",
                      color: "white",
                      fontSize: "13px",
                      backgroundColor: "#fa9fb5",
                      padding: "5px",
                      borderRadius: "20px",
                    }}
                  >
                    {" "}
                    Event
                  </span>

                  <span
                    style={{
                      marginRight: "4px",
                      color: "white",
                      fontSize: "13px",
                      backgroundColor: "#fdbb84",
                      padding: "5px",
                      borderRadius: "20px",
                    }}
                  >
                    {" "}
                    Important
                  </span>
                </div>
              </div>
              <div
                style={{
                  marginTop: "-5px",
                  padding: "15px",
                  backgroundColor: themeStyle.primaryColorLight,
                  borderRadius: "25px",
                  height: "31vh",
                }}
              >
                {eventsList.length != 0 ? (
                  <h4
                    style={{
                      margin: "-5px",
                      marginLeft: "5px",
                      fontWeight: "bold",
                      color: themeStyle.primaryColor,
                    }}
                  >
                    Upcoming events
                  </h4>
                ) : (
                  <Fragment>
                    <Link
                      to="/events"
                      style={{
                        textDecoration: "none",
                        color: "black",
                      }}
                    >
                      <Box
                        borderRadius="15px"
                        style={{
                          backgroundColor: colorList[0],
                          borderBottom: "4px solid " + colorList2[colorIndex],
                          width: "100%",
                          padding: "2px",
                          height: "30vh",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          flexDirection: "column",
                          backgroundImage:
                            "linear-gradient(to right, rgba(251,237,217, 0.9), rgba(251,237,217, 0.9)), url(https://img.freepik.com/free-vector/education-pattern-background-doodle-style_53876-115365.jpg?w=740)",
                        }}
                      >
                        <div style={{ textAlign: "center" }}>
                          <Fab
                            size="large"
                            style={{
                              border: "3px solid blue",
                              boxShadow: "none",
                              backgroundColor: "transparent",
                            }}
                            aria-label="add"
                          >
                            <PriorityHighIcon
                              style={{
                                color: themeStyle.primaryColor,
                              }}
                            />
                          </Fab>
                          <h4 style={{ color: "black" }}>
                            No upcoming Events.
                          </h4>
                          <div
                            style={{
                              color: "grey",
                              marginTop: "-5px",
                            }}
                          >
                            Click Here to go to events page.
                          </div>
                        </div>
                      </Box>
                    </Link>
                  </Fragment>
                )}

                <div style={{ marginTop: "15px" }}>
                  {eventsList.slice(0, 2).map((event, index) => (
                    <Link
                      to="/events"
                      path
                      style={{ textDecoration: "none", color: "black" }}
                    >
                      <CardActionArea
                        style={{
                          height: "80px",
                          backgroundColor: colorList2[index],
                          borderRadius: "15px",
                          marginBottom: "15px",
                        }}
                      >
                        <Grid
                          container
                          spacing={1}
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <Grid
                            item
                            md={8}
                            style={{
                              marginTop: "-3px",
                              marginLeft: "5px",
                            }}
                          >
                            <p
                              style={{
                                margin: "0px 0px 3px 10px",
                                fontWeight: "bold",
                                fontSize: "16px",
                                color: "white",
                              }}
                            >
                              {event["name"]}
                            </p>

                            <p
                              style={{
                                margin: "0px 0px 5px 10px",
                                fontSize: "13px",
                                color: "white",
                              }}
                            >
                              {moment(event["date"], "DD-MM-YYYY").format(
                                "Do MMMM, YYYY"
                              )}
                            </p>
                            <p
                              style={{
                                margin: "-3px 0px 0px 10px",
                                fontSize: "15px",
                                color: colorList3[colorIndex],
                              }}
                            >
                              {event["venue"]}
                            </p>
                          </Grid>
                          <Grid item>
                            <ChevronRightIcon
                              style={{
                                fontSize: "40px",
                                color: colorList3[colorIndex],
                              }}
                            />
                          </Grid>
                        </Grid>
                      </CardActionArea>
                    </Link>
                  ))}
                  {eventsList.length >= 2 ? (
                    <Link
                      to="/events"
                      style={{
                        textDecoration: "none",
                        color: "black",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          textAlign: "right",
                          color: themeStyle.primaryColor,
                        }}
                      >
                        <h4>More Events...</h4>
                      </div>
                    </Link>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </Grid>
            <Grid item md={3} style={{ width: "100%" }}>
              <h2>Student Leave Requests</h2>
              <div
                style={{
                  display: "flex",
                  marginTop: "17px",
                  justifyContent: "space-between",

                  width: "100%",
                }}
              >
                <Link
                  style={{
                    textDecoration: "none",
                    color: "black",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                  to={{
                    pathname: "/leave_requests",
                    search: "?tab=LEAVEREQUESTS",
                  }}
                >
                  <div
                    style={{
                      backgroundColor: "#31a354",
                      color: "white",
                      boxShadow: "none",
                      height: "100px",
                      width: "100px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "15px",
                    }}
                  >
                    <h1
                      style={{
                        fontSize: "50px",
                        marginTop: "3px",
                        textAlign: "center",
                      }}
                    >
                      {studentLeaveRequests["APPROVED"]}
                    </h1>
                  </div>
                  <div
                    style={{
                      textAlign: "center",
                      fontSize: "15px",
                      marginTop: "10px",
                      color: "#31a354",

                      width: "100%",
                    }}
                  >
                    APPROVED{" "}
                  </div>
                </Link>
                <Link
                  style={{
                    textDecoration: "none",
                    color: "black",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                  to={{
                    pathname: "/leave_requests",
                    search: "?tab=LEAVEREQUESTS",
                  }}
                >
                  <div
                    style={{
                      backgroundColor: "#ff3333",
                      color: "white",
                      boxShadow: "none",
                      height: "100px",
                      width: "100px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "15px",
                    }}
                  >
                    <h1 style={{ fontSize: "50px" }}>
                      {studentLeaveRequests["REJECTED"]}
                    </h1>
                  </div>
                  <div
                    style={{
                      textAlign: "center",
                      fontSize: "15px",
                      marginTop: "10px",
                      color: "#ff3333",
                    }}
                  >
                    REJECTED
                  </div>
                </Link>
                <Link
                  style={{
                    textDecoration: "none",
                    color: "black",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                  to={{
                    pathname: "/leave_requests",
                    search: "?tab=LEAVEREQUESTS",
                  }}
                >
                  <div
                    style={{
                      backgroundColor: themeStyle.primaryColor,
                      color: "white",
                      boxShadow: "none",
                      height: "100px",
                      width: "100px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "15px",
                    }}
                  >
                    <h1 style={{ fontSize: "50px" }}>
                      {studentLeaveRequests["PENDING"]}
                    </h1>
                  </div>
                  <div
                    style={{
                      textAlign: "center",
                      fontSize: "15px",
                      marginTop: "10px",
                      color: themeStyle.primaryColor,
                    }}
                  >
                    PENDING
                  </div>
                </Link>
              </div>

              <h2>Submission Status</h2>
              {assignmentList.length == 0 ? (
                <Fragment>
                  <Link
                    to="/events"
                    style={{
                      textDecoration: "none",
                      color: "black",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        backgroundColor: "#fbedd9",
                        borderRadius: "15px",
                        alignItems: "center",
                        height: "63%",
                        borderBottom: "4px solid " + colorList2[1],
                        backgroundImage:
                          "linear-gradient(to right, rgba(237,248,233, 0.9), rgba(237,248,233, 0.9)), url(https://img.freepik.com/free-vector/education-pattern-background-doodle-style_53876-115365.jpg?w=740)",
                      }}
                    >
                      <div style={{ textAlign: "center" }}>
                        <Fab
                          size="large"
                          style={{
                            height: "100px",
                            width: "100px",
                            border: "5px solid #31a354",
                            boxShadow: "none",
                            backgroundColor: "transparent",
                          }}
                          aria-label="add"
                        >
                          <CheckIcon
                            style={{
                              color: "#31a354",
                              fontSize: "75px",
                            }}
                          />
                        </Fab>
                        <h4 style={{ color: "black" }}>
                          No pending submissions.
                        </h4>
                        <div
                          style={{
                            color: "grey",
                            marginTop: "-5px",
                          }}
                        >
                          Click Here to go to events page.
                        </div>
                      </div>
                    </div>
                  </Link>
                </Fragment>
              ) : (
                ""
              )}
              {assignmentList.slice(0, 5).map((assignment, index) => (
                <div>
                  <span>
                    {assignment["class_id"]} {assignment["division"]}
                    {" - "}
                    {assignment["subject"]}
                  </span>
                  <Box
                    display="flex"
                    alignItems="center"
                    style={{ marginBottom: "10px" }}
                  >
                    <Box
                      mr={1}
                      sx={{
                        width: "100%",
                        color: colorList2[index],
                      }}
                    >
                      {assignment["total_students"] == 0 ? (
                        <div
                          style={{
                            fontSize: "13px",
                            color: colorList2[index],
                          }}
                        >
                          No Students in{" "}
                          {" " +
                            assignment["class_id"] +
                            " " +
                            assignment["division"]}
                        </div>
                      ) : (
                        <LinearProgress
                          variant="determinate"
                          color="inherit"
                          style={{
                            height: "10px",
                            borderRadius: "5px",
                          }}
                          value={
                            (assignment["submitted"] /
                              assignment["total_students"]) *
                            100
                          }
                        />
                      )}
                    </Box>
                    <Box minWidth={35}>
                      <Typography variant="body2" color="textSecondary">
                        {(
                          (assignment["submitted"] /
                            assignment["total_students"]) *
                          100
                        ).toFixed(2)}
                        %
                      </Typography>
                    </Box>
                  </Box>
                </div>
              ))}
            </Grid>
            <Grid item md={3}>
              {exams.length != 0 ? (
                <h2>Upcoming Examinations</h2>
              ) : (
                <Fragment>
                  <h2>No Upcoming Examinations</h2>
                  <Link
                    to="/events"
                    style={{
                      textDecoration: "none",
                      color: "black",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        backgroundColor: "#f0f3f7",
                        borderRadius: "15px",
                        alignItems: "center",
                        height: "50%",
                        borderBottom: "4px solid " + colorList2[3],
                        backgroundImage:
                          "linear-gradient(to right, rgba(215,236,255, 0.9), rgba(215,236,255, 0.9)), url(https://img.freepik.com/free-vector/education-pattern-background-doodle-style_53876-115365.jpg?w=740)",
                      }}
                    >
                      <div style={{ textAlign: "center" }}>
                        <Fab
                          size="large"
                          style={{
                            height: "100px",
                            width: "100px",
                            border: "5px solid #31a354",
                            boxShadow: "none",
                            backgroundColor: "transparent",
                          }}
                          aria-label="add"
                        >
                          <CheckIcon
                            style={{
                              color: "#31a354",
                              fontSize: "75px",
                            }}
                          />
                        </Fab>
                        <h4 style={{ color: "black" }}>
                          No upcoming Examinations.
                        </h4>
                        <div
                          style={{
                            color: "grey",
                            marginTop: "-5px",
                          }}
                        >
                          Click Here to go to events page.
                        </div>
                      </div>
                    </div>
                  </Link>
                </Fragment>
              )}
              <div style={{ marginTop: "-15px" }}>
                {exams.slice(0, 5).map((exam, index) => (
                  <Link to="/exams" style={{ textDecoration: "none" }}>
                    <CardActionArea
                      fullWidth
                      style={{
                        borderRadius: "15px",
                        padding: "12px 10px 10px 8px",
                        backgroundColor: colorList[index],
                        marginBottom: "15px",
                      }}
                    >
                      <Grid
                        container
                        spacing={1}
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Grid
                          item
                          md={8}
                          style={{
                            marginTop: "-3px",
                            marginLeft: "5px",
                          }}
                        >
                          <div
                            style={{
                              marginBottom: "2px",
                              fontSize: "16px",

                              color: colorList2[index],
                            }}
                          >
                            {exam["test"]}
                          </div>
                          <div
                            style={{
                              marginBottom: "1px",
                              fontSize: "13px",

                              color: colorList2[index],
                            }}
                          >
                            {exam["semester"]}
                          </div>
                          <span
                            style={{
                              fontSize: "13px",

                              color: "black",
                            }}
                          >
                            {moment(exam["start_date"], "DD-MM-YYYY").format(
                              "Do MMMM, YYYY"
                            ) +
                              " - " +
                              moment(exam["end_date"], "DD-MM-YYYY").format(
                                "Do MMMM, YYYY"
                              )}
                          </span>
                        </Grid>
                        <Grid item>
                          <ChevronRightIcon
                            style={{
                              fontSize: "40px",
                              color: colorList3[colorIndex],
                            }}
                          />
                        </Grid>
                      </Grid>
                    </CardActionArea>
                  </Link>
                ))}
              </div>
              <br />
              <div style={{ marginTop: "15px" }}>
                <div
                  style={{
                    color: themeStyle.primaryColor,
                    fontSize: "18px",
                    fontWeight: "bold",
                  }}
                >
                  Noticeboard
                </div>
                {noticeBoard[Object.keys(noticeBoard)[0]].length != 0 ? (
                  <Fragment>
                    <div>
                      {Object.keys(noticeBoard)[0].charAt(0).toUpperCase() +
                        Object.keys(noticeBoard)[0].slice(1)}
                    </div>
                    <Grid container spacing={1.5}>
                      {noticeBoard[Object.keys(noticeBoard)[0]].map(
                        (noti, index) => (
                          <Grid item md={12}>
                            <Box
                              padding={1}
                              borderRadius="5px"
                              sx={{ "&:hover": { opacity: "1 !important" } }}
                              style={{
                                borderRadius: "15px",
                                border:
                                  "4px solid " + themeStyle.primaryColorLight,
                                backgroundColor: "white",
                                boxShadow: "none",
                                height: "100%",
                                marginBottom: "5px",
                              }}
                            >
                              <Box style={{ marginLeft: "5px" }}>
                                <Grid
                                  container
                                  spacing={2}
                                  justifyContent="space-between"
                                >
                                  <Grid item md={10}>
                                    <div
                                      style={{
                                        color: themeStyle.secondaryColor,
                                        fontSize: "19px",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {noti["title"]}
                                    </div>
                                    <div
                                      style={{
                                        fontSize: "15px",
                                        color: "grey",
                                      }}
                                    >
                                      {moment(
                                        noti["date"],
                                        "DD-MM-YYYY"
                                      ).format("Do MMMM, YYYY")}
                                    </div>
                                    <div
                                      style={{
                                        fontSize: "15px",
                                      }}
                                    >
                                      {noti["venue"]}
                                    </div>
                                    <div
                                      style={{
                                        margin: "10px 0px 0px 0px",
                                        fontSize: "15px",
                                      }}
                                    >
                                      {noti["desc"]}
                                    </div>
                                    {Object.keys(noti).includes("link") ? (
                                      <a
                                        href={noti["link"]}
                                        target="_blank"
                                        style={{
                                          margin: "10px 0px 0px 0px",
                                          fontSize: "15px",
                                        }}
                                      >
                                        View Document
                                      </a>
                                    ) : (
                                      ""
                                    )}
                                  </Grid>
                                </Grid>
                              </Box>
                            </Box>
                          </Grid>
                        )
                      )}
                    </Grid>
                  </Fragment>
                ) : (
                  <div>
                    Recent Notices from the noticeboard will appear here.
                    <br />
                    <br />
                    Greetings from {MAIN_TITLE} Recent Notices from the
                    noticeboard will appear here.
                    <br />
                    <br /> Have a great day ahead!
                  </div>
                )}
                <Link to="/support" style={{ textDecoration: "none" }}>
                  <div
                    style={{
                      padding: "15px",
                      borderRadius: "15px",
                      backgroundColor: themeStyle.primaryColorLight,
                      color: themeStyle.primaryColor,
                      fontSize: "18px",
                      marginTop: "15px",
                    }}
                  >
                    Need help? Feel free to contact us for support!
                  </div>
                </Link>
              </div>
            </Grid>
          </Grid>
        </Fade>
      );
    } else {
      return (
        <div style={{ marginTop: "75px" }}>
          {Object.keys(noticeBoard).map((category) => (
            <Fragment>
              {noticeBoard[category].length != 0 ? (
                <Fragment>
                  <h2>
                    For {category.charAt(0).toUpperCase() + category.slice(1)}
                  </h2>
                  <Grid container spacing={1.5}>
                    {noticeBoard[category].map((noti, index) => (
                      <Grid item md={3}>
                        <Box
                          padding={1}
                          borderRadius="5px"
                          sx={{ "&:hover": { opacity: "1 !important" } }}
                          style={{
                            borderRadius: "15px",
                            backgroundColor: colorList[index],
                            boxShadow: "none",
                            height: "100%",
                            marginBottom: "5px",
                          }}
                        >
                          <Box style={{ marginLeft: "5px" }}>
                            <Grid
                              container
                              spacing={2}
                              justifyContent="space-between"
                            >
                              <Grid item md={10}>
                                <div
                                  style={{
                                    color: themeStyle.secondaryColor,
                                    fontSize: "19px",
                                  }}
                                >
                                  {noti["title"]}
                                </div>
                                <div
                                  style={{
                                    fontSize: "15px",
                                  }}
                                >
                                  {moment(noti["date"], "DD-MM-YYYY").format(
                                    "Do MMMM, YYYY"
                                  )}
                                </div>
                                <div
                                  style={{
                                    fontSize: "15px",
                                  }}
                                >
                                  {noti["venue"]}
                                </div>
                                <div
                                  style={{
                                    margin: "10px 0px 0px 0px",
                                    fontSize: "15px",
                                  }}
                                >
                                  {noti["desc"]}
                                </div>
                                {Object.keys(noti).includes("link") ? (
                                  <a
                                    href={noti["link"]}
                                    target="_blank"
                                    style={{
                                      margin: "10px 0px 0px 0px",
                                      fontSize: "15px",
                                    }}
                                  >
                                    View Document
                                  </a>
                                ) : (
                                  ""
                                )}
                              </Grid>
                            </Grid>
                          </Box>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </Fragment>
              ) : (
                <span>
                  <>
                    {category == "everyone" ||
                    category == "parents" ||
                    category == "students" ||
                    category == "teachers" ? (
                      <h3
                        style={{
                          color: "grey",
                          fontSize: 18,
                        }}
                      >
                        No Notice for {category}
                      </h3>
                    ) : (
                      <></>
                    )}
                  </>
                </span>
              )}
            </Fragment>
          ))}
        </div>
      );
    }
  }

  if (!state.auth.isLoading) {
    if (state.auth.isAuthenticated) {
      if (state.auth.user.is_teacher) {
        if (isLoading) {
          return (
            <Fragment>
              <Sidebar />
              <div
                style={{
                  maxWidth: "88vw",
                  marginTop: "45vh",
                  marginLeft: "8vw",
                  backgroundColor: "white",
                  height: "100%",
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <CircularProgress />
              </div>
            </Fragment>
          );
        } else {
          return (
            <Fragment>
              <Sidebar
                tabs={
                  <Grid container spacing={1.5} justifyContent={"flex-end"}>
                    <Grid item md={4}>
                      {selectedPage == "HOME" ? (
                        <Button
                          fullWidth
                          value={"HOME"}
                          onClick={handlePageSelect}
                          p={2}
                          style={{
                            backgroundColor: themeStyle.primaryColor,
                            color: "white",
                            height: "30px",
                          }}
                          borderRadius={6}
                        >
                          <h3
                            style={{
                              marginTop: "3px",
                              fontSize: "15px",
                            }}
                          >
                            HOME
                          </h3>
                        </Button>
                      ) : (
                        <Button
                          fullWidth
                          value={"HOME"}
                          onClick={handlePageSelect}
                          p={2}
                          style={{
                            backgroundColor: themeStyle.primaryColorLight,
                            color: "white",
                            height: "30px",
                          }}
                          borderRadius={6}
                        >
                          <h3
                            style={{
                              marginTop: "17px",
                              fontSize: "15px",
                              color: themeStyle.secondaryColor,
                            }}
                          >
                            HOME
                          </h3>
                        </Button>
                      )}
                    </Grid>
                    <Grid item md={4}>
                      {selectedPage == "NOTICEBOARD" ? (
                        <Button
                          fullWidth
                          value="NOTICEBOARD"
                          onClick={handlePageSelect}
                          p={2}
                          style={{
                            backgroundColor: themeStyle.primaryColor,
                            color: "white",
                            height: "30px",
                          }}
                          borderRadius={6}
                        >
                          <h3
                            style={{
                              marginTop: "3px",
                              fontSize: "15px",
                            }}
                          >
                            NOTICEBOARD
                          </h3>
                        </Button>
                      ) : (
                        <Button
                          fullWidth
                          value="NOTICEBOARD"
                          onClick={handlePageSelect}
                          p={2}
                          style={{
                            backgroundColor: themeStyle.primaryColorLight,
                            color: "white",
                            height: "30px",
                          }}
                          borderRadius={6}
                        >
                          <h3
                            style={{
                              marginTop: "3px",
                              fontSize: "15px",
                              color: themeStyle.secondaryColor,
                            }}
                          >
                            NOTICEBOARD
                          </h3>
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                }
              />
              <div
                style={{
                  margin: "66px 6px 0px 75px",
                  backgroundColor: "#fcfefc",
                  border: "1px solid #cdc",
                  padding: "3px 9px"
                }}
              >
                {getContent()}
              </div>
            </Fragment>
          );
        }
      } else {
        createAlert("ERROR", "Permission Denied.", "Please Login as Teacher");
        dispatch({
          type: "AUTH_ERROR",
        });
        dispatch({ type: "AUTH_ERROR" });
      }
    } else {
      dispatch({ type: "AUTH_ERROR" });
    }
  } else {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          backgroundColor: "white",
          marginTop: "46vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }
}

export default Dashboard;
